import { resetAccessGroupsStore } from './useAccessGroupsStore/actions'
import { resetEveryActionStore } from './useEveryActionStore/actions'
import { resetGlobalStore } from './useGlobalStore/actions'
import { resetInboxStore } from './useInboxStore/actions'
import { resetMobilizeStore } from './useMobilizeStore/actions'

export const initializeStores = (isUserChange = true) => {
  if (isUserChange) {
    resetAccessGroupsStore()
    resetGlobalStore()
  }
  resetInboxStore()
  resetEveryActionStore()
  resetMobilizeStore()
}
